// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.light-purple {
  color: #CE5BEB;
}
.larger {
  font-size: 24px;
  font-weight: 600;
  width: 180px;
  height: 75px;
  border-radius: 15px;
}
.header-layout {
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.16);
}
.header-menu-dropdown > ul > li > span > p {
  margin: 0 !important;
}
.landing-wrapper {
  scroll-snap-type: y mandatory;
  width: 100%;
  height: 100dvh;
  scroll-behavior: smooth;
}
.landing-head {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100dvh;
  width: 100%;
  padding: 100px 60px 0px 60px;
}
.landing-content {
  scroll-snap-align: start;
  height: 100vh;
  width: 100%;
  padding: 0px 60px 0px 60px;
}
.welcome-content {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.image-wrapper {
  display: flex;
}
.memo-image {
  margin-bottom: 10px;
  margin-left: -5px;
  width: auto;
  height: 100px;
}
.memo-text {
  font-weight: 600;
  font-size: 48px;
  margin-bottom: 10;
}
.landing-image {
  width: 100%;
  height: auto;
}
.landing-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.sponsor-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sponsor-image {
  width: auto;
  height: 80px;
}
.slide-in-bottom {
  animation: slide-in-bottom 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.info-icon:hover {
  color: #1677ff;
}
.profile-avatar:hover {
  color: #1677ff !important;
}
@keyframes slide-in-bottom {
  0% {
    transform: translateY(20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@media screen and(max-width: 576px) {
  .ant-layout-header {
    padding-inline: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layout/index.less"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAEA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAAJ;AAGA;EACI,wCAAA;AADJ;AAIA;EACI,oBAAA;AAFJ;AAKA;EACI,6BAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;AAHJ;AAMA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;AAJJ;AAOA;EACI,wBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;AALJ;AAQA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AANJ;AASA;EACI,aAAA;AAPJ;AAUA;EACI,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AARJ;AAWA;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;AATJ;AAYA;EACI,WAAA;EACA,YAAA;AAVJ;AAaA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAXJ;AAcA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;AAeA;EACI,WAAA;EACA,YAAA;AAbJ;AAgBA;EAEI,yEAAA;AAdJ;AAiBA;EACA,cAAA;AAfA;AAkBA;EACA,yBAAA;AAhBA;AAiCA;EACI;IAEI,2BAAA;IACA,UAAA;EAnBN;EAsBE;IAEI,wBAAA;IACA,UAAA;EApBN;AACF;AAuBA;EACI;IACI,oBAAA;EArBN;AACF","sourcesContent":[".light-purple {\n    color: #CE5BEB;\n}\n\n.larger {\n    font-size: 24px;\n    font-weight: 600;\n    width: 180px;\n    height: 75px;\n    border-radius: 15px;\n}\n\n.header-layout {\n    box-shadow: 0 0 40px rgba(0, 0, 0, 0.16)\n}\n\n.header-menu-dropdown>ul>li>span>p {\n    margin: 0 !important;\n}\n\n.landing-wrapper {\n    scroll-snap-type: y mandatory;\n    width: 100%;\n    height: 100dvh;\n    scroll-behavior: smooth;\n}\n\n.landing-head {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100dvh;\n    width: 100%;\n    padding: 100px 60px 0px 60px;\n}\n\n.landing-content {\n    scroll-snap-align: start;\n    height: 100vh;\n    width: 100%;\n    padding: 0px 60px 0px 60px;\n}\n\n.welcome-content {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n}\n\n.image-wrapper {\n    display: flex;\n}\n\n.memo-image {\n    margin-bottom: 10px;\n    margin-left: -5px;\n    width: auto;\n    height: 100px;\n}\n\n.memo-text {\n    font-weight: 600;\n    font-size: 48px;\n    margin-bottom: 10;\n}\n\n.landing-image {\n    width: 100%;\n    height: auto;\n}\n\n.landing-footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.sponsor-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sponsor-image {\n    width: auto;\n    height: 80px;\n}\n\n.slide-in-bottom {\n    -webkit-animation: slide-in-bottom 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n    animation: slide-in-bottom 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n\n.info-icon:hover{\ncolor: #1677ff\n}\n\n.profile-avatar:hover{\ncolor: #1677ff !important\n}\n\n@-webkit-keyframes slide-in-bottom {\n    0% {\n        -webkit-transform: translateY(1000px);\n        transform: translateY(1000px);\n        opacity: 0;\n    }\n\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes slide-in-bottom {\n    0% {\n        -webkit-transform: translateY(20px);\n        transform: translateY(20px);\n        opacity: 0;\n    }\n\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@media screen and(max-width: 576px) {\n    .ant-layout-header {\n        padding-inline: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
